import MEMBER_ROLES from './MemberRoles'

// These are all of the roles that we feel comfortable exposing via our frontend production code
const USER_ROLES = {
    ...MEMBER_ROLES,
    MEMBER: 'ROLE_MEMBER',
    CHECKOUT: 'ROLE_CHECKOUT',
    ONLINE_EVENT_HOST: 'ROLE_ONLINE_EVENT_HOST',
    ADVERTISING_ADMIN: 'ROLE_ADVERTISING_ADMIN',
    PAYMENT_ADMIN: 'ROLE_PAYMENT_ADMIN',
    RECOMMENDATION_ADMIN: 'ROLE_RECOMMENDATION_ADMIN',
    HR_ADMIN: 'ROLE_HR_ADMIN',
    EVENTS_ADMIN: 'ROLE_EVENTS_ADMIN',
    GROUPS_ADMIN: 'ROLE_GROUPS_ADMIN',
    CM_ADMIN: 'ROLE_CM_ADMIN',
    UNTAPPED_SUPPORT_ADMIN: 'ROLE_UNTAPPED_SUPPORT_ADMIN',
    MR_ADMIN: 'ROLE_MR_ADMIN',
    PM_ADMIN: 'ROLE_PM_ADMIN',
    ENGINEERING_ADMIN: 'ROLE_ENGINEERING_ADMIN',
    MASTER_ADMIN: 'ROLE_MASTER_ADMIN',
    PRIVILEGE_ADMIN: 'ROLE_PRIVILEGE_ADMIN',
    DUNNING: 'ROLE_DUNNING',
    DUNNING_V2: 'ROLE_DUNNING_V2',
    DUNNING_V3: 'ROLE_DUNNING_V3',
    BUSINESS_ADMIN: 'ROLE_BUSINESS_ADMIN',
    MESSAGES_SCAM_WHITELISTED: 'ROLE_MESSAGES_SCAM_WHITELISTED',
    POTENTIAL_SCAMMER: 'ROLE_POTENTIAL_SCAMMER',
    PREMIUM_PARTNER_INVITEE: 'ROLE_PREMIUM_PARTNER_INVITEE',
    APPROVED_UPGRADE_PENDING: 'ROLE_APPROVED_UPGRADE_PENDING',
    PREVIOUS_ADMIN: 'ROLE_PREVIOUS_ADMIN',
    EMPLOYEE_PARTNER: 'ROLE_EMPLOYEE_PARTNER',
} as const

export default USER_ROLES
